import { Box, Typography } from '@mui/material';
import { defineMessage, FormattedMessage } from 'react-intl';
import { ChartTooltipSingle } from '../../../graph/ChartTooltipSingle';
import { TooltipData } from '../../../graph/types';

const openYoutubeAtThisMomentMessage = defineMessage({
  id: 'logger.youtubeStats.openYoutubeAtThisMoment',
  defaultMessage: 'Click para ir a YouTube en este momento',
});

type YoutubeStatsSingleTooltipProps = {
  data: TooltipData;
};

/**
 * Single-line hover tooltip with channel stats and a click-through prompt to YouTube.
 */
export function YoutubeStatsSingleTooltip({ data }: YoutubeStatsSingleTooltipProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <ChartTooltipSingle data={data} />
      <Typography variant="caption" sx={{ display: 'block', lineHeight: 1.4, color: 'grey.300' }}>
        <FormattedMessage {...openYoutubeAtThisMomentMessage} />
      </Typography>
    </Box>
  );
}
